import { dateStrFormatRegex, dateStrRegex } from './regex';

// Check that the date in the input value comes after the date in the specified fieldPath
const isValidDate = dateStr => {
	if (dateStr && !dateStr.match(dateStrFormatRegex)) {
		return 'Invalid date format. Please use MM/DD/YYYY';
	}
	if (dateStr && !dateStr.match(dateStrRegex)) {
		return 'Invalid date entered';
	}
	return undefined;
};

export default isValidDate;
